import React from "react";
import { Link } from "react-router-dom";
import "./PublicNav.css";

function LogoMark({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className="zyft-logo-mark"
    >
      <path
        d="M4 20V8.5C4 7.67 4.41 6.9 5.1 6.43L11.1 2.34C11.65 1.97 12.35 1.97 12.9 2.34L18.9 6.43C19.59 6.9 20 7.67 20 8.5V20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M9 20V13.5C9 12.67 9.67 12 10.5 12H13.5C14.33 12 15 12.67 15 13.5V20"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.5H16.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function PublicNav() {
  return (
    <nav className="public-nav">
      <div className="public-nav__inner">
        <div className="public-nav__left">
          <Link to="/" className="public-nav__brand" aria-label="Zyft.AI Home">
            <LogoMark />
            <span className="public-nav__brandText">
              Zyft<span className="public-nav__brandDot">.AI</span>
            </span>
          </Link>
        </div>

        <div className="public-nav__links">
          <a href="/#features" className="public-nav__link">
            Platform
            <span className="public-nav__underline" />
          </a>
          <Link to="/about" className="public-nav__link">
            About
            <span className="public-nav__underline" />
          </Link>
          <Link to="/contact" className="public-nav__link">
            Contact
            <span className="public-nav__underline" />
          </Link>
        </div>

        <div className="public-nav__cta">
          <Link to="/login" className="public-nav__signin">
            Sign In
          </Link>
          <a
            href="mailto:sales@zyft.ai?subject=Zyft%20Demo%20Request"
            className="public-nav__demo"
          >
            Request Demo
          </a>
        </div>
        
      </div>
    </nav>
  );
}
